/**
 * Componente helper para los iconos de servicios usando Lucide Icons
 * 
 * Iconos basados en el prototipo de Alloy y Figma:
 * - Infraestructura TI: Monitor
 * - Ciberseguridad: Shield
 * - Soporte Técnico: Headphones
 * - Networking: Network
 * - Continuidad Eléctrica: Zap
 * - Infraestructura Eléctrica: Power
 * - Mantenimiento Industrial: Wrench
 * - Data Center: Database
 * 
 * Referencias:
 * - Prototipo Alloy: https://alloy.app/carlos-navarro/p/e2cb8140-6a4c-4d33-ad70-e3332c9a60cc
 * - Lucide Icons: https://lucide.dev/icons/
 */

import React from 'react';
import { 
    Monitor, 
    Shield, 
    Headphones, 
    Network, 
    Zap, 
    Power, 
    Wrench, 
    Database 
} from 'lucide-react';

interface IconProps {
    color?: string;
    size?: number;
}

export const MonitorIcon: React.FC<IconProps> = ({ color = "#0A3058", size = 40 }) => (
    <Monitor 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const ShieldIcon: React.FC<IconProps> = ({ color = "#0A3058", size = 40 }) => (
    <Shield 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const HeadphonesIcon: React.FC<IconProps> = ({ color = "#0A3058", size = 40 }) => (
    <Headphones 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const NetworkIcon: React.FC<IconProps> = ({ color = "#0A3058", size = 40 }) => (
    <Network 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const ZapIcon: React.FC<IconProps> = ({ color = "#DDB70F", size = 40 }) => (
    <Zap 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const DollarSignIcon: React.FC<IconProps> = ({ color = "#DDB70F", size = 40 }) => (
    <Power 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const WrenchIcon: React.FC<IconProps> = ({ color = "#DDB70F", size = 40 }) => (
    <Wrench 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

export const DatabaseIcon: React.FC<IconProps> = ({ color = "#0A3058", size = 40 }) => (
    <Database 
        size={size} 
        stroke={color} 
        strokeWidth={2.5}
        fill="none"
        style={{ display: 'block', color: color, stroke: color }}
        color={color}
    />
);

